<template>
  <div class="detail-container">
    <el-button @click="$router.back()">返回商品列表</el-button>
    <el-card v-loading="loading" :loading-text="'加载中...'">
      <el-descriptions column="1" border>
        <el-descriptions-item label="商品 ID">{{ merchandise.merchandise_id }}</el-descriptions-item>
        <el-descriptions-item label="商品名称">{{ merchandise.name }}</el-descriptions-item>
        <el-descriptions-item label="商品规格">{{ merchandise.specification || '无' }}</el-descriptions-item>
        <el-descriptions-item label="商品分类">{{ merchandise.category || '无' }}</el-descriptions-item>
      </el-descriptions>
      <div style="text-align: right; margin-top: 20px;">
        <el-button type="primary" @click="openEditDialog">编辑商品</el-button>
        <el-button type="danger" @click="handleDelete">删除商品</el-button>
      </div>
    </el-card>

    <!-- 编辑商品弹窗 -->
    <el-dialog title="编辑商品" v-model="editDialogVisible" width="400px">
      <el-form :model="editForm" ref="editForm" :rules="rules" label-width="80px">
        <el-form-item label="商品名称" prop="name">
          <el-input v-model="editForm.name"></el-input>
        </el-form-item>
        <el-form-item label="商品规格" prop="specification">
          <el-input v-model="editForm.specification"></el-input>
        </el-form-item>
        <el-form-item label="商品分类" prop="category">
          <el-input v-model="editForm.category"></el-input>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="editDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitEdit">保存</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
// 导入商品模块API（需确保 @/api/merchandises.js 已正确封装商品接口）
import merchandiseAPI from '@/api/merchandises';

export default {
  props: {
    id: {
      type: [Number, String],
      required: true,
    },
  },
  data() {
    return {
      merchandise: {}, // 商品详情数据
      loading: false,
      editDialogVisible: false,
      editForm: {
        name: '',
        specification: '',
        category: '',
      },
      rules: {
        name: [
          { required: true, message: '请输入商品名称', trigger: 'blur' },
        ],
      },
    };
  },
  created() {
    this.fetchMerchandiseDetail(); // 初始化加载商品详情
  },
  methods: {
    // 获取商品详情
    async fetchMerchandiseDetail() {
      this.loading = true;
      try {
        // 调用商品API的“按ID查询”方法
        const res = await merchandiseAPI.inquireMerchandise(this.id);
        this.merchandise = res;
        // 初始化编辑表单（同步商品数据）
        this.editForm = {
          name: this.merchandise.name,
          specification: this.merchandise.specification,
          category: this.merchandise.category,
        };
      } catch (error) {
        console.error('获取商品详情失败：', error);
        this.$message.error(error.message || '加载商品详情失败，请重试');
      } finally {
        this.loading = false;
      }
    },

    // 打开“编辑商品”弹窗
    openEditDialog() {
      this.editDialogVisible = true;
    },

    // 提交“编辑商品”表单
    async submitEdit() {
      this.$refs.editForm.validate(async (valid) => {
        if (valid) {
          try {
            // 调用商品API的“更新商品”方法
            await merchandiseAPI.updateMerchandise(this.id, this.editForm);
            this.$message.success('商品编辑成功');
            this.editDialogVisible = false;
            this.fetchMerchandiseDetail(); // 刷新商品详情
          } catch (error) {
            console.error('编辑商品失败：', error);
            this.$message.error(error.message || '编辑商品失败，请重试');
          }
        }
      });
    },

    // 删除商品
    async handleDelete() {
      try {
        // 确认弹窗（Element Plus 风格）
        await this.$confirm('确定删除该商品吗？删除后数据不可恢复！', '警告', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        });
        // 调用商品API的“删除商品”方法
        await merchandiseAPI.deleteMerchandise(this.id);
        this.$message.success('商品删除成功');
        this.$router.push('/merchandises'); // 跳转回商品列表页
      } catch (error) {
        // 处理“取消删除”的情况
        if (error === 'cancel' || error.name === 'CanceledError') {
          this.$message.info('已取消删除');
        } else {
          console.error('删除商品失败：', error);
          this.$message.error(error.message || '删除商品失败，请重试');
        }
      }
    },
  },
};
</script>

<style scoped>
.detail-container {
  padding: 20px;
}
</style>